import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate, useRouteError } from 'react-router-dom';

const RouteErrorBoundary = () => {
  const navigate = useNavigate();
  const error = useRouteError();

  return (
    <Result
      status="error"
      title="路由错误"
      subTitle={error?.message || '页面加载失败'}
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          返回首页
        </Button>
      }
    />
  );
};

export default RouteErrorBoundary; 